export default __webpack_public_path__ + "static/wamo-dont-pay-more-for-more-fcad5b4fe0182cad636353697488c517.jpg";